import { Controller } from '@hotwired/stimulus'
import { turboFrame, current } from '../helpers'
import { formsProjectCardTablesPath, formsProjectCardTableColumnsPath } from '../routes'

const CARD_TABLES_FRAME_ID = 'forms_card_tables'
const COLUMNS_FRAME_ID = 'forms_columns'

export default class extends Controller {
  static values = { formId: String, projectId: String }

  selectDestination ({ detail: { projectId, target } }) {
    if (target !== 'card_column') return
    this.projectIdValue = projectId
    this.removeCardTables()
    this.removeColumns()
    if (projectId) this.insertCardTablesFrame(projectId)
  }

  selectCardTable ({ target }) {
    this.removeColumns()
    if (target.value) this.insertColumnsFrame(target.value)
  }

  // Private

  insertCardTablesFrame (projectId) {
    const cardTablesFrame = turboFrame(
      CARD_TABLES_FRAME_ID,
      formsProjectCardTablesPath(current.account.id, projectId, { form_id: this.formIdValue }),
      { class: 'block' }
    )
    this.element.appendChild(cardTablesFrame)
  }

  insertColumnsFrame (cardTableId) {
    const columnsFrame = turboFrame(
      COLUMNS_FRAME_ID,
      formsProjectCardTableColumnsPath(current.account.id, this.projectIdValue, cardTableId, { form_id: this.formIdValue }),
      { class: 'block mt-4' }
    )
    this.element.appendChild(columnsFrame)
  }

  removeCardTables () {
    document.getElementById(CARD_TABLES_FRAME_ID)?.remove()
  }

  removeColumns () {
    document.getElementById(COLUMNS_FRAME_ID)?.remove()
  }
}
